export default __webpack_public_path__ + "static/media/zendanian.beead257.jpg";